import { render, staticRenderFns } from "./PRICE.vue?vue&type=template&id=6fed1953&scoped=true&"
import script from "./PRICE.vue?vue&type=script&lang=js&"
export * from "./PRICE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fed1953",
  null
  
)

export default component.exports